var $ = jQuery.noConflict();

$(function(){

    $('.faq-items__item:not(.faq-items__item--article) .faq-items__item-content').hide();

    function toggleFaqItem($trigger){

        if($trigger.hasClass('expand')){
            $trigger.removeClass('expand');
            $trigger.next().slideUp();
            $trigger.find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
            $trigger.attr('aria-expanded', false);

        } else {
            $trigger.addClass('expand');
            $trigger.next().slideDown();
            $trigger.find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $trigger.attr('aria-expanded', true);
        }

    }

    $('.faq-items__item:not(.faq-items__item--article) .faq-items__item-title').on('click', function(){
        toggleFaqItem($(this));
    });

    // Keyboard support for role="button" triggers (Enter / Space)
    $('.faq-items__item:not(.faq-items__item--article) .faq-items__item-title').on('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32){
            e.preventDefault();
            toggleFaqItem($(this));
        }
    });

    // Preserve native <details>/<summary> semantics while animating article FAQ answers.
    $(document)
        .off('click.faqArticle', 'details.faq-items__item--article > .faq-items__item-title')
        .on('click.faqArticle', 'details.faq-items__item--article > .faq-items__item-title', function(e){
            e.preventDefault();

            var $summary = $(this);
            var $details = $summary.parent('details');
            var $content = $details.children('.faq-items__item-content');

            if($details.data('faqAnimating')){
                return;
            }

            $details.data('faqAnimating', true);

            if($details.prop('open')){
                $summary.removeClass('expand');
                $content.stop(true, true).slideUp(400, function(){
                    $details.prop('open', false).data('faqAnimating', false);
                });
            } else {
                $summary.addClass('expand');
                $content.stop(true, true).hide();
                $details.prop('open', true);

                requestAnimationFrame(function(){
                    $content.slideDown(400, function(){
                        $details.data('faqAnimating', false);
                    });
                });
            }
        });

}) // document ready
